import React from "react"
import { Link } from "gatsby"
import Layout from "../../components/Layout"
import Pagetitle from "../../components/Pagetitle"
import Seo from "../../components/Seo"
import RelatedPlatforms from "../../components/RelatedPlatforms"
import { PLATFORM_GUIDE_OG_IMAGE } from "../../data/platforms"

const MicrosoftAdsPage = () => (
  <Layout>
    <Seo
      title="Adding your feed to Microsoft Ads"
      description="Step-by-step instructions for adding your Upfeed product feed to Microsoft Merchant Center to run Bing Shopping campaigns."
      image={PLATFORM_GUIDE_OG_IMAGE}
    />
    <div className="container">
      <div className="row justify-content-center">
        <div className="getting-started col-md-8">
          <Link to="/getting-started/#platforms" className="back-link">
            ← All platforms
          </Link>
          <Pagetitle>Adding your feed to Microsoft Ads</Pagetitle>
          <p>
            Follow these steps to connect your UpFeed product feed to Microsoft
            Merchant Center so you can run Shopping campaigns on Bing, MSN, and
            the Microsoft Audience Network.
          </p>

          <div className="prerequisites">
            <p>Before you start, make sure you have:</p>
            <ul>
              <li>
                <Link to="/getting-started/#generate">
                  Generated your product feed
                </Link>{" "}
                and copied the feed URL from the app homepage.
              </li>
              <li>A Microsoft Advertising account.</li>
            </ul>
          </div>

          <h2>Setting up Microsoft Merchant Center</h2>
          <ul>
            <li>
              Log in to{" "}
              <a href="https://ads.microsoft.com" target="_blank" rel="noreferrer">
                Microsoft Advertising
              </a>{" "}
              and open the 'Tools' menu in the top navigation.
            </li>
            <li>
              Click 'Microsoft Merchant Center' and create a new store (or
              select your existing store).
            </li>
            <li>
              Inside your store, navigate to 'Catalog Management' and click
              'Create catalog'.
            </li>
            <li>Give your catalog a name.</li>
            <li>
              Under 'Feed file settings' select 'Scheduled feed' as the input
              method.
            </li>
            <li>Paste your product feed URL from the app.</li>
            <li>Set the schedule to 'Daily' and click 'Save'.</li>
          </ul>

          <h2>Running Shopping Campaigns</h2>
          <p>
            Once your feed has been processed and products are approved, go to
            Campaigns and create a new Shopping Campaign. Select your Merchant
            Center store and configure your bidding and targeting to start
            serving product ads across Microsoft's search and audience network.
          </p>

          <RelatedPlatforms currentSlug="microsoft-ads" />
        </div>
      </div>
    </div>
  </Layout>
)

export default MicrosoftAdsPage
